import { useMutation } from '@tanstack/react-query';
import { useAxios } from './context.mjs';
import { filterByKey } from './utils/object.mjs';
import getQueryKey from './utils/getQueryKey.mjs';

function identity(param) {
  return param;
}
function useMutationFromRemote(params) {
  const { instances } = useAxios();
  const {
    remote,
    options = {},
    axiosInstance,
    paramsTransformer = identity
  } = params;
  const [remoteFn, defaultConfig] = remote(axiosInstance ?? instances.json);
  const mutateFn = async (variables) => {
    const response = await remoteFn(paramsTransformer(variables));
    return response.data;
  };
  const { onError, onMutate, onSettled, onSuccess, ...rest } = options;
  const mutationOptions = filterByKey(
    rest,
    (restMutateOptionKey) => restMutateOptionKey !== "mutationFn" && restMutateOptionKey !== "mutationKey"
  );
  if (onMutate !== void 0) {
    mutationOptions.onMutate = (variable) => {
      const parsedVariable = paramsTransformer(variable);
      return onMutate?.(parsedVariable);
    };
  }
  if (onSuccess !== void 0) {
    mutationOptions.onSuccess = (data, variables, context) => {
      return onSuccess(data, paramsTransformer(variables), context);
    };
  }
  if (onError !== void 0) {
    mutationOptions.onError = (error, variables, context) => {
      return onError(error, paramsTransformer(variables), context);
    };
  }
  if (onSettled !== void 0) {
    mutationOptions.onSettled = (data, error, variable, context) => {
      return onSettled(data, error, paramsTransformer(variable), context);
    };
  }
  return useMutation({
    ...mutationOptions,
    mutationFn: mutateFn,
    mutationKey: getQueryKey({
      url: `__USE_MUTATION_FROM_REMOTE__`,
      ...defaultConfig
    })
  });
}

export { useMutationFromRemote as default };
//# sourceMappingURL=useMutationFromRemote.mjs.map
